const ImageUtils = {
    imageUrl: null,
    img: null,

    init(imageUrl) {
        const self = this;

        const p = new Promise((resolve, reject) => {
            if (imageUrl) {
                const { getExtension, getOrientation } = self;

                const img = new Image();
                img.src = imageUrl;

                img.onload = () => {
                    const obj = {};

                    if (img.width > 0 && img.height > 0) {
                        obj.width = img.width;
                        obj.height = img.height;
                        obj.type = getExtension(imageUrl);
                        obj.aspectRatio = parseFloat(img.width / img.height).toFixed(2);
                        obj.inverseAspectRatio = parseFloat(img.height / img.width).toFixed(2);
                        obj.orientation = getOrientation(img);
                    }

                    resolve(obj);
                };

                img.onerror = () => {
                    reject(new Error('Error: Unable to read image'));
                };

                self.imageUrl = imageUrl;
                self.img = img;
            } else {
                reject(new Error('Error: Invalid image path'));
            }
        });

        return p;
    },

    rendition(image, rendition) {
        return `${image}/jcr:content/renditions/${rendition}.${ImageUtils.getExtension(image)}`;
    },

    getExtension(imageUrl) {
        return imageUrl?.split(/[#?]/)[0].split('.').pop().trim();
    },

    getOrientation(img) {
        let orientation = 'unknown';

        if (img.width > img.height) {
            orientation = 'landscape';
        } else if (img.width < img.height) {
            orientation = 'portrait';
        } else if (img.width === img.height) {
            orientation = 'square';
        }

        return orientation;
    },

    isWebp() {
        const p = new Promise((resolve) => {
            const src = 'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA';
            const img = new Image();
            img.onload = () => resolve((img.width > 0) && (img.height > 0));
            img.onerror = () => resolve(false);
            img.src = `data:image/webp;base64,${src}`;
        });
        return p;
    },
};

export default ImageUtils;
